import { Component } from '@angular/core';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';

@Component({
  selector: 'whatsapp-flotante',
  templateUrl: './whatsapp-flotante.component.html',
  styleUrls: ['./whatsapp-flotante.component.scss']
})
export class WhatsappFlotanteComponent {
  constructor(private genServ: EcommerceGenericoService) { }

  get numero(): string {
    return this.genServ.getNumeroWhatsapp();
  }

  get link(): string {
    const soloNumeros = (this.numero || '').replace(/[^\d]/g, '');
    return `https://wa.me/${soloNumeros}`;
  }
}
